import { useCallback, useEffect, useState } from 'react';
import { fetchHitFavorites, saveHitFavorites } from '../../services/api';

// Every mounted user of one instrument's list (TOSPanel, Live feed, Dashboard Favorites) hears each save.
export const EVENT = 'hit-favorites-changed';

// Starred real timeframes of one instrument: the Favorites channel of the Live feed.
export default function useHitFavorites(account, broker, symbol) {
  const [favs, setFavs] = useState([]);
  const ready = Boolean(account && broker && symbol);

  useEffect(() => {
    setFavs([]);
    if (!ready) return undefined;
    let alive = true;
    fetchHitFavorites(account, broker, symbol).then((res) => alive && setFavs(res));
    const onChange = ({ detail }) => {
      if (detail.account === account && detail.broker === broker && detail.symbol === symbol) setFavs(detail.favs);
    };
    window.addEventListener(EVENT, onChange);
    return () => { alive = false; window.removeEventListener(EVENT, onChange); };
  }, [ready, account, broker, symbol]);

  // Optimistic; a failed save rolls back. ponytail: whole list, last write wins across devices.
  const toggleFav = useCallback(async (tf) => {
    const prev = favs;
    const next = favs.includes(tf) ? favs.filter((f) => f !== tf) : [...favs, tf];
    setFavs(next);
    const saved = await saveHitFavorites(account, broker, symbol, next);
    const result = saved || prev;
    setFavs(result);
    if (saved) window.dispatchEvent(new CustomEvent(EVENT, { detail: { account, broker, symbol, favs: result } }));
  }, [favs, account, broker, symbol]);

  return { favs, toggleFav: ready ? toggleFav : null };
}
